import React from "react";
import { BsEye } from "react-icons/bs";
import { useNavigate } from "react-router";
const CompletedActivities = () => {
    const navigate=useNavigate()
    const submissionData = [
        {
            studentName: "John Doe",
            subjectName: "English",
            topicName: "Essay Writing",
            initialGrades: "23",
            TotalGrades:"34",
            FinalGrades:"25",
            startDate: "Jan 08, 2025",
            endDate: "Jan 18, 2025"
        },
        {
            studentName: "Smith",
            subjectName: "English",
            topicName: "Essay Writing",
            initialGrades: "23",
            TotalGrades:"34",
            FinalGrades:"25",
            startDate: "Jan 08, 2025",
            endDate: "Jan 18, 2025"
        },
    ];


    return (
        <div className="">
            <div className=" w-full flex flex-col p-8">

                {/* details */}
                <div className="w-full bg-r400 flex gap-8 items-center mt-8 relative ">
                    <p className="absolute bg-white text-2xl font-medium -top-6 left-8 p-2">
                        School Details
                    </p>
                    <div className=" flex items-center gap-12 border w-1/2 rounded-lg border-gray-400 h-[350px] p-8 text-nowrap">
                        <div>
                            <div className="flex items-center justify-between">
                                <div className="flex flex-col text-[20px]">
                                    <p className="text-gray-600">Supervisor Name:</p>
                                    <p className="text-gray-700">Ahmed Ali</p>
                                </div>

                            </div>

                            <div className="flex items-center justify-between mt-4">
                                <div className="flex flex-col text-[20px]">
                                    <p className="text-gray-600">Start Date:</p>
                                    <p className="text-gray-700">Jan 8,2025</p>
                                </div>

                            </div>

                            <div className="flex items-center justify-between mt-4">
                                <div className="flex flex-col text-[20px]">
                                    <p className="text-gray-600">Class</p>
                                    <p className="text-gray-700">Alpha White</p>
                                </div>

                            </div>

                            <div className="flex items-center justify-between mt-4">
                                <div className="flex flex-col text-[20px]">
                                    <p className="text-gray-600">Subjects</p>
                                    <p className="text-gray-700">English/ Science/ Pak Studies/ Islamic Studies/ Econimcs</p>
                                </div>

                            </div>
                        </div>
                        <div className="space-y-4 flex flex-col justify-start  h-full ml-[-150px] ">
                            <div className="flex flex-col text-[20px]">
                                <p className="text-gray-600">Activity Name</p>
                                <p className="text-gray-700">Creative Writing</p>
                            </div>
                            <div className="flex flex-col text-[20px]">
                                <p className="text-gray-600">End Date:</p>
                                <p className="text-gray-700">Jan 5,2003</p>
                            </div>
                            <div className="flex flex-col text-[20px]">
                                <p className="text-gray-600">Region</p>
                                <p className="text-gray-700">North</p>
                            </div>
                        </div>
                    </div>
                    <div className="border w-1/2 rounded-lg border-gray-400 h-[350px] p-8 relative">
                        <p className="absolute bg-white text-2xl font-medium -top-6 left-8 p-2">
                            Submission Analytics
                        </p>
                        <div className="flex flex-col items-center gap-6">
                            <div className="flex flex-items justify-between w-full  text-[20px] ">
                                <p className="text-gray-600">
                                    Number of students who received the Activity:
                                </p>
                                <p className="text-gray-700">12</p>
                            </div>{" "}
                            <div className="flex flex-items justify-between w-full  text-[20px] ">
                                <p className="text-gray-600">
                                    Number of students who participated in the Activity:
                                </p>
                                <p className="text-gray-700">12</p>
                            </div>
                            <div className="flex flex-items justify-between w-full  text-[20px] ">
                                <p className="text-gray-600">
                                    Number of students who completed the Activity:
                                </p>
                                <p className="text-gray-700">12</p>
                            </div>
                            <div className="flex flex-items justify-between w-full  text-[20px] ">
                                <p className="text-gray-600">
                                    Number of students who didn’t started the Activity:
                                </p>
                                <p className="text-gray-700">12</p>
                            </div>
                            <div className="flex flex-items justify-between w-full  text-[20px] ">
                                <p className="text-gray-600">
                                    Number of submissions that have been graded:
                                </p>
                                <p className="text-gray-700">12</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="flex items-center gap-8 mt-6">
                <button className="bg-blue-600 h-[40px] w-[180px] text-white font-medium rounded-lg hover:border hover:border-blue-600 hover:bg-gray-100 hover:text-blue-600">
              In-Progress Activities
            </button>
            <button className="bg-blue-600 h-[40px] w-[180px] text-white font-medium rounded-lg hover:border hover:border-blue-600 hover:bg-gray-100 hover:text-blue-600">
           Completed Activities
            </button>
                </div> */}
                <div className="bg-white border-gray-400 rounded-lg border-2 w-full mt-8 relative p-4 ">
                    <p className="absolute bg-white text-2xl font-medium -top-8 left-8 p-2">
                        Submission Details
                    </p>
                    <div className="overflow-x-auto">
                        <table className="w-full ">
                            <thead className="text-[16px] font-medium">
                                <tr>
                                    <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                        Student Name
                                    </th>
                                    <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                        Subject Name
                                    </th>
                                    <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                        Topic Name
                                    </th>
                                    
                                    <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                        Start Date
                                    </th>
                                    <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                        End Date
                                    </th>
                                    <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                        Initial Grades
                                    </th>
                                    <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                        Final Grades
                                    </th>
                                    <th className="px-4 py-3 text-center text-gray-700 font-semibold">
                                        Options
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-400">
                                {submissionData.map((submission, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                        <td className="px-4 py-3 whitespace-nowrap">
                                            {submission.studentName}
                                        </td>
                                        <td className="px-4 py-3 whitespace-nowrap">
                                            {submission.subjectName}
                                        </td>
                                        <td className="px-4 py-3 whitespace-nowrap">
                                            {submission.topicName}
                                        </td>
                                        {/* <td className="px-4 py-3 whitespace-nowrap">
                                            <span className={`w-[100px] h-[30px] rounded-lg flex items-center justify-center  gap-1 text-sm ${submission.status === 'Completed' ? 'bg-blue-200' : 'bg-gray-200'}`}>
                                                <FaCircle className={` h-3 w-3 ${submission.status === 'Completed' ? 'text-green-400' : 'text-gray-400'}`} />
                                                {submission.status}
                                            </span>
                                        </td> */}
                                        <td className="px-4 py-3 whitespace-nowrap">
                                            {submission.startDate}
                                        </td>
                                        <td className="px-4 py-3 whitespace-nowrap">
                                            {submission.endDate}
                                        </td>
                                        <td className="px-4 py-3 whitespace-nowrap">
                                            {submission.initialGrades}/{submission.TotalGrades}
                                        </td>
                                        <td className="px-4 py-3 whitespace-nowrap">
                                            {submission.FinalGrades}/{submission.TotalGrades}
                                        </td>
                                        <td className="py-3 -px-5 whitespace-nowrap  flex justify-center items-center">
                                            <button onClick={()=>navigate("/supervisor/compare-grades")} className="flex items-center justify-center gap-1 bg-blue-600 text-white px-3 py-1 rounded-lg text-sm">
                                                <BsEye />
                                                View Details
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompletedActivities;
